import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "simpleToolbar",
    "advancedToolbar"
  ];

  connect() {
    this.#restorePreference();
  }

  toggle() {
    this.toolbar = this.toolbar === "simple" ? "advanced" : "simple";

    this.#toggleToolbar();
    this.#updatePreference();
  }

  #toggleToolbar() {
    this.simpleToolbarTarget.classList.toggle("hidden", this.toolbar === "advanced");
    this.advancedToolbarTarget.classList.toggle("hidden", this.toolbar === "simple");
  }

  #updatePreference() {
    localStorage.setItem("data_table.toolbar", this.toolbar);
  }

  #restorePreference() {
    this.toolbar = localStorage.getItem("data_table.toolbar") || "simple";
    this.#toggleToolbar();
  }
}
